import React, {FC} from "react";
import {HideOnScroll} from "../sharedComponents/HideOnScroll";
import {Link, Typography} from "@material-ui/core";
import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        footer: {
            backgroundColor: theme.palette.secondary.dark,
            height: 80,
            width: "100%",
            position: "fixed",
            bottom: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: "space-between"
        },
        footerCopyRight: {
            marginLeft: theme.spacing(9),
            color: theme.palette.grey["A700"]
        },
        links: {
            marginRight: theme.spacing(9),
            color: theme.palette.grey["300"]
        }
    }),
);

export const OrderEngineFooter: FC<{ hideFooter: boolean }> = ({hideFooter}) => {
    const classes = useStyles();
    return (
        <HideOnScroll direction="up" extraTrigger={hideFooter}>
            <div className={classes.footer}>
                <Typography variant="body2" className={classes.footerCopyRight}>
                    © 2021 Die fleißigen Enkel
                </Typography>
                <div className={classes.links}>
                    <Link
                        variant="body2" color="inherit" style={{marginRight: 8}}
                        target="_blank"
                        href={"https://www.diefleissigenenkel.de/impressum/"}
                    >
                        Impressum
                    </Link>
                    <Link
                        variant="body2"
                        color="inherit"
                        style={{marginRight: 8}}
                        target="_blank"
                        href={"https://www.diefleissigenenkel.de/kontakt/"}
                    >
                        Kontakt
                    </Link>
                    <Link
                        variant="body2"
                        color="inherit"
                        target="_blank"
                        href={"https://www.diefleissigenenkel.de/datenschutzerklaerung/"}
                    >
                        Datenschutzerklärung
                    </Link>
                </div>
            </div>
        </HideOnScroll>
    );
}
